"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("./Box"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var px = function px(a) {
  return typeof a === 'number' ? "".concat(a, "px") : a;
};

var Avatar = (0, _styledComponents["default"])(_Box["default"].withComponent('img'))(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.pill;
}, function (props) {
  return px(props.size);
}, function (props) {
  return px(props.size);
});
Avatar.displayName = 'Avatar';
Avatar.propTypes = {
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
Avatar.defaultProps = {
  theme: _theme["default"],
  size: 48
};
var _default = Avatar;
exports["default"] = _default;